// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FsyCa","content":"styles_content__2npTT","row":"styles_row__1WcFp","footer":"styles_footer__1bKrx","phraseLength":"styles_phraseLength__TmfeN"};